import store from '@/store'
import storage from '@/utils/storage'
import router from '@/router'

import { WECHAT_APPID } from '@/utils/constants'
import request from '@/utils/request'
import { Notify } from 'vant'

function _getUrlParams(url: string) {
    if (url.indexOf('?') <= 0 ) {return {}}
    url = url.substr(url.indexOf('?') + 1)
    const urlSplit = url.split('&')
    // 获取全部参数及其值
    const result: any = {}
    for (let i = 0; i < urlSplit.length; i++) {
        const info = urlSplit[i].split('=')
        result[info[0]] = decodeURI(info[1])
    }
    return result
}
const wxAuthorize = (link?: string) => {
    // 已经授权登录过的就不用再授权了
    console.log(store.state.openId)
    if (store.state.openId) {return}
    if (!link) {link = window.location.href}
    if (link.indexOf('localhost') > 0) {
        return console.error('未登录')
    }
    const params = _getUrlParams(link)  // 地址解析
    if (params.code) {
      wxAuth(params.code, link)
    } else {
        const uri = encodeURIComponent(link)
        const authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WECHAT_APPID}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
        window.location.href = authURL
    }
}
const wxAuth = (code: string, link: string) => {
  const params = {
    wechatName:"西安鄠邑气象",
    code
  }
	return request.get(`/wechatServ/oAuth`, params)
	.then(userInfo => {
    const openId = userInfo.openid
		store.commit('setOpenId', openId )
	}).catch(error => {
		console.error(error)
	})
}
export default { wxAuthorize }
